import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const CONVERTER_STUDY_ADAM_DATASET_LANG: {
  ADD_TARGET_DATASET_DIALOG_TITLE: MvnCodeFE;
  ADD_TARGET_DATASET_DIALOG_DESCRIPTION: MvnCodeFE;
  EDIT_TARGET_DATASET_DIALOG_TITLE: MvnCodeFE;
  EDIT_TARGET_DATASET_DIALOG_DESCRIPTION: MvnCodeFE;
  TARGET_DATASET_DIALOG_DATASET_NAME_PLACEHOLDER: MvnCodeFE;
  TARGET_DATASET_DIALOG_DATASET_NAME_MAX_LENGTH_VALIDATION: MvnCodeFE;
  TARGET_DATASET_DIALOG_DATASET_NAME_MIN_LENGTH_VALIDATION: MvnCodeFE;
  TARGET_DATASET_DIALOG_DATASET_NAME_PREFIX_VALIDATION: MvnCodeFE;
  TARGET_DATASET_DIALOG_DATASET_NAME_FORMAT_VALIDATION: MvnCodeFE;
  TARGET_DATASET_DIALOG_DATASET_NAME_ADSL_RESERVED_VALIDATION: MvnCodeFE;
  TARGET_DATASET_DIALOG_DATASET_NAME_ADDL_RESERVED_VALIDATION: MvnCodeFE;
  TARGET_DATASET_DIALOG_DATASET_NAME_EXISTS_VALIDATION: MvnCodeFE;

  TARGET_DATASET_DIALOG_DATASET_LABEL_PLACEHOLDER: MvnCodeFE;
  TARGET_DATASET_DIALOG_DATASET_LABEL_MAX_LENGTH_VALIDATION: MvnCodeFE;
  TARGET_DATASET_DIALOG_DATASET_LABEL_LETTER_VALIDATION: MvnCodeFE;
  TARGET_DATASET_CREATE_SUCCEED: MvnCodeFE;
  TARGET_DATASET_CREATE_FAIL: MvnCodeFE;
  TARGET_DATASET_UPDATE_SUCCEED: MvnCodeFE;
  TARGET_DATASET_UPDATE_FAIL: MvnCodeFE;
  TARGET_DATASET_DELETE_SUCCEED: MvnCodeFE;
  TARGET_DATASET_DELETE_FAIL: MvnCodeFE;

  TARGET_VARIABLE_CREATE_SUCCEED: MvnCodeFE;
  TARGET_VARIABLE_CREATE_FAIL: MvnCodeFE;
  TARGET_VARIABLE_UPDATE_SUCCEED: MvnCodeFE;
  TARGET_VARIABLE_UPDATE_FAIL: MvnCodeFE;
  TARGET_VARIABLE_DELETE_SUCCEED: MvnCodeFE;
  TARGET_VARIABLE_DELETE_FAIL: MvnCodeFE;

  TARGET_VARIABLE_EDIT_DIALOG_TITLE: MvnCodeFE;
  TARGET_VARIABLE_EDIT_DIALOG_DESCRIPTION: MvnCodeFE;
  TARGET_VARIABLE_LABEL_EDIT_SUCCEED: MvnCodeFE;
  TARGET_VARIABLE_LABEL_EDIT_FAIL: MvnCodeFE;
  TARGET_VARIABLE_LABEL_SAME_AS_DEFAULT_VALIDATION: MvnCodeFE;
  TARGET_VARIABLE_LABEL_ELLIPSIS_VALIDATION: MvnCodeFE;
  TARGET_VARIABLE_LABEL_ELLIPSIS_ICON_TOOLTIP: MvnCodeFE;

  CONVENTION_SETTING_DIALOG_TITLE: MvnCodeFE;
  CONVENTION_SETTING_DIALOG_DESCRIPTION: MvnCodeFE;

  CONVENTION_TIMING_HELP_TEXT: MvnCodeFE;
  CONVENTION_TIMING_NAME_PLACEHOLDER: MvnCodeFE;
  CONVENTION_TIMING_LABEL_PLACEHOLDER: MvnCodeFE;
  CONVENTION_TIMING_LABEL_MANDATORY_VALIDATION: MvnCodeFE;

  CONVENTION_INDEXED_W_HELP_TEXT: MvnCodeFE;
  CONVENTION_INDEXED_XX_HELP_TEXT: MvnCodeFE;
  CONVENTION_INDEXED_Y_HELP_TEXT: MvnCodeFE;
  CONVENTION_INDEXED_ZZ_HELP_TEXT: MvnCodeFE;

  CONVENTION_INDEXED_RANGE_PLACEHOLDER: MvnCodeFE;
  CONVENTION_INDEXED_RANGE_VALIDATION: MvnCodeFE;

  CONVENTION_SDTM_COPY_HELP_TEXT: MvnCodeFE;
  CONVENTION_SDTM_COPY_PLACEHOLDER: MvnCodeFE;
  CONVENTION_SDTM_COPY_NO_VARIABLE_VALIDATION: MvnCodeFE;

  ALPHA_UPPERCASE_VALIDATION: MvnCodeFE;
  MIN_LENGTH_VALIDATION: MvnCodeFE;
  MAX_LENGTH_VALIDATION: MvnCodeFE;
  DUPLICATION_VALIDATION: MvnCodeFE;

  HEADER_ACTION_VARIABLES_CONFIGURATION: MvnCodeFE;

  SELECTION_BAR_SELECTED_COUNT: MvnCodeFE;
  SELECTION_BAR_SELECT_ALL_BUTTON: MvnCodeFE;
  SELECTION_BAR_UNCHECK_BUTTON: MvnCodeFE;
  SELECTION_BAR_ADD_TARGET_VARIABLE_BUTTON: MvnCodeFE;

  VARIABLE_ENABLE_REORDERING_BUTTON: MvnCodeFE;
  VARIABLE_DISABLE_REORDERING_BUTTON: MvnCodeFE;
  KEY_REORDERING_TITLE: MvnCodeFE;
  KEY_RESET_TITLE: MvnCodeFE;

  VARIABLE_REORDERING_SUCCEED: MvnCodeFE;
  VARIABLE_REORDERING_FAIL: MvnCodeFE;

  USER_DEFINED_TARGET_VARIABLE_ADD_BUTTON: MvnCodeFE;
  USER_DEFINED_TARGET_VARIABLE_DIALOG_TITLE: MvnCodeFE;
  USER_DEFINED_TARGET_VARIABLE_DIALOG_DESCRIPTION: MvnCodeFE;
  USER_DEFINED_TARGET_VARIABLE_DIALOG_NAME_PLACEHOLDER: MvnCodeFE;
  USER_DEFINED_TARGET_VARIABLE_DIALOG_LABEL_PLACEHOLDER: MvnCodeFE;

  LIBRARY_SAVE_DIALOG_TITLE: MvnCodeFE;
  LIBRARY_SAVE_DIALOG_DESCRIPTION: MvnCodeFE;
  LIBRARY_SAVE_NAME_PLACEHOLDER: MvnCodeFE;
  LIBRARY_SAVE_NAME_REQUIRED_VALIDATION: MvnCodeFE;
  LIBRARY_SAVE_NAME_EXISTS_VALIDATION: MvnCodeFE;

  LIBRARY_LOAD_DIALOG_TITLE: MvnCodeFE;
  LIBRARY_LOAD_DIALOG_DESCRIPTION: MvnCodeFE;

  LIBRARY_DELETE_DIALOG_TITLE: MvnCodeFE;
  LIBRARY_DELETE_DIALOG_DESCRIPTION: MvnCodeFE;

  RESET_CONFIRM_DIALOG_TITLE: MvnCodeFE;
  RESET_CONFIRM_DIALOG_DESCRIPTION: MvnCodeFE;

  RESET_ALL_SETTINGS_SUCCEED: MvnCodeFE;
  RESET_ALL_SETTINGS_FAIL: MvnCodeFE;

  LIBRARY_SAVE_SUCCEED: MvnCodeFE;
  LIBRARY_SAVE_FAIL: MvnCodeFE;
  LIBRARY_LOAD_SUCCEED: MvnCodeFE;
  LIBRARY_LOAD_FAIL: MvnCodeFE;
  LIBRARY_DELETE_SUCCEED: MvnCodeFE;
  LIBRARY_DELETE_FAIL: MvnCodeFE;
  LIBRARY_RENAME_SUCCEED: MvnCodeFE;
  LIBRARY_RENAME_FAIL: MvnCodeFE;
  LIBRARY_LIMIT_EXCEEDED: MvnCodeFE;

  EXPORT_SUCCEED: MvnCodeFE;
  EXPORT_FAIL: MvnCodeFE;

  // Pair Variable Configuration
  PAIR_VARIABLE_DIALOG_TITLE: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_DESCRIPTION: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_TAB_LIST: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_TAB_AI_EXTRACTION: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_TAB_LOAD: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_TAB_SAVE: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_EMPTY_STATE_MESSAGE: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_ADD_ROW_BUTTON: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_IMPORT_BUTTON: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_LIBRARY_BUTTON: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_COUNT_TOTAL: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_LIBRARY_NAME_LABEL: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_LIBRARY_NAME_PLACEHOLDER: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_TABLE_HEADER_CHECK: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_TABLE_HEADER_LIBRARY_NAME: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_TABLE_HEADER_CREATED_AT: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_TABLE_HEADER_PAIR_COUNT: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_TABLE_HEADER_ACTION: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_DUPLICATE_VALIDATION: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_MAX_PAIR_VARIABLES_TOOLTIP: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_VARIABLE_CREATE_SUCCEED: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_VARIABLE_CREATE_FAIL: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_VARIABLE_UPDATE_SUCCEED: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_VARIABLE_UPDATE_FAIL: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_VARIABLE_DELETE_SUCCEED: MvnCodeFE;
  PAIR_VARIABLE_DIALOG_VARIABLE_DELETE_FAIL: MvnCodeFE;
  PAIR_VARIABLE_ADD_CONFIRM_DIALOG_TITLE: MvnCodeFE;
  PAIR_VARIABLE_ADD_CONFIRM_DIALOG_DESCRIPTION: MvnCodeFE;
  PAIR_VARIABLE_REMOVE_CONFIRM_DIALOG_TITLE: MvnCodeFE;
  PAIR_VARIABLE_REMOVE_CONFIRM_DIALOG_DESCRIPTION: MvnCodeFE;
  PAIR_VARIABLE_UNCHECK_CONFIRM_DIALOG_TITLE: MvnCodeFE;
  PAIR_VARIABLE_UNCHECK_CONFIRM_DIALOG_DESCRIPTION: MvnCodeFE;
  PAIR_VARIABLE_UNSAVED_CHANGES_DIALOG_TITLE: MvnCodeFE;
  PAIR_VARIABLE_UNSAVED_CHANGES_DIALOG_DESCRIPTION: MvnCodeFE;
  PAIR_VARIABLE_UNSAVED_CHANGES_DIALOG_CLOSE_WITHOUT_SAVING_BUTTON: MvnCodeFE;

  // 변수 추가 Dialog (Bulk / Predecessor) — CDISC-2549
  ADD_VARIABLES_DIALOG_TITLE: MvnCodeFE;
  ADD_VARIABLES_DIALOG_DESCRIPTION: MvnCodeFE;
  ADD_VARIABLES_EMPTY_STATE: MvnCodeFE;
  ADD_VARIABLES_ADD_ROW_BUTTON: MvnCodeFE;
  ADD_VARIABLES_ROW_LIMIT_GUIDE: MvnCodeFE;
  ADD_VARIABLES_HEADER_MODEL: MvnCodeFE;
  ADD_VARIABLES_HEADER_DATASET: MvnCodeFE;
  ADD_VARIABLES_HEADER_VARIABLE: MvnCodeFE;
  ADD_VARIABLES_HEADER_LABEL: MvnCodeFE;
  ADD_VARIABLES_HEADER_DATA_TYPE: MvnCodeFE;
  ADD_VARIABLES_SELECT_PLACEHOLDER: MvnCodeFE;
  ADD_VARIABLES_TYPE_CUSTOM_LABEL: MvnCodeFE;
  ADD_VARIABLES_CUSTOM_NAME_PLACEHOLDER: MvnCodeFE;
  ADD_VARIABLES_CUSTOM_LABEL_PLACEHOLDER: MvnCodeFE;
  ADD_VARIABLES_DATA_TYPE_CHAR: MvnCodeFE;
  ADD_VARIABLES_DATA_TYPE_NUM: MvnCodeFE;
  ADD_VARIABLES_SUCCEED: MvnCodeFE;
  ADD_VARIABLES_FAIL: MvnCodeFE;
  ADD_VARIABLES_NAME_IN_USE: MvnCodeFE;
  ADD_VARIABLES_NAME_DUPLICATE_IN_MODAL: MvnCodeFE;
  ADD_VARIABLES_CANDIDATE_DUPLICATE_TOOLTIP: MvnCodeFE;
  ADD_VARIABLES_CUSTOM_NAME_RULE_VIOLATION: MvnCodeFE;
  ADD_VARIABLES_NO_SDTM_DATASET: MvnCodeFE;
  PREDECESSOR_BADGE_LABEL: MvnCodeFE;
  PREDECESSOR_BADGE_DANGLING: MvnCodeFE;
} = {
  ADD_TARGET_DATASET_DIALOG_TITLE: {
    ko: "Target Dataset 생성",
    en: "Create Target Dataset",
  },
  ADD_TARGET_DATASET_DIALOG_DESCRIPTION: {
    ko: "선택한 데이터 구조를 기반으로 새로운 Target Dataset을 생성합니다.",
    en: "Create a new target dataset based on the selected data structure.",
  },
  TARGET_DATASET_DIALOG_DATASET_NAME_PLACEHOLDER: {
    ko: "예: ADAE01, ADTTSAF",
    en: "e.g., ADAE01, ADTTSAF",
  },
  TARGET_DATASET_DIALOG_DATASET_NAME_MAX_LENGTH_VALIDATION: {
    ko: "데이터셋 이름은 최대 8자까지 입력 가능합니다. (현재: {n}자)",
    en: "Dataset name must be 8 characters or less. (Current: {n} characters)",
  },
  TARGET_DATASET_DIALOG_DATASET_NAME_MIN_LENGTH_VALIDATION: {
    ko: "데이터셋 이름은 최소 3자 이상이어야 합니다.",
    en: "Dataset name must be at least 3 characters.",
  },
  TARGET_DATASET_DIALOG_DATASET_NAME_PREFIX_VALIDATION: {
    ko: "ADaM 데이터셋 이름은 'AD, AX'로 시작해야 합니다.",
    en: "ADaM dataset name must start with 'AD' or 'AX'.",
  },
  TARGET_DATASET_DIALOG_DATASET_NAME_FORMAT_VALIDATION: {
    ko: "영문 대문자(A-Z), 숫자(0-9)만 사용 가능합니다.",
    en: "Only uppercase letters (A-Z) and numbers (0-9) are allowed.",
  },
  TARGET_DATASET_DIALOG_DATASET_NAME_ADSL_RESERVED_VALIDATION: {
    ko: "'ADSL'은 Subject-Level Dataset용 예약어입니다.",
    en: "'ADSL' is reserved for Subject-Level Analysis Dataset.",
  },
  TARGET_DATASET_DIALOG_DATASET_NAME_ADDL_RESERVED_VALIDATION: {
    ko: "'ADDL'은 Device-Level Dataset용 예약어입니다.",
    en: "'ADDL' is reserved for Device-Level Analysis Dataset.",
  },
  TARGET_DATASET_DIALOG_DATASET_NAME_EXISTS_VALIDATION: {
    ko: "이미 존재하는 데이터셋 이름입니다.",
    en: "This dataset name already exists.",
  },
  TARGET_DATASET_DIALOG_DATASET_LABEL_PLACEHOLDER: {
    ko: "예: Adverse Event Analysis Dataset 01",
    en: "e.g., Adverse Event Analysis Dataset 01",
  },
  TARGET_DATASET_DIALOG_DATASET_LABEL_MAX_LENGTH_VALIDATION: {
    ko: "레이블은 최대 40자까지 입력 가능합니다.",
    en: "Label must be 40 characters or less.",
  },
  TARGET_DATASET_DIALOG_DATASET_LABEL_LETTER_VALIDATION: {
    ko: "영문 대소문자, 숫자(0-9)만 사용 가능합니다.",
    en: "Only uppercase letters (A-Z) and numbers (0-9) are allowed.",
  },
  EDIT_TARGET_DATASET_DIALOG_TITLE: {
    ko: "Target Dataset 수정",
    en: "Edit Target Dataset",
  },
  EDIT_TARGET_DATASET_DIALOG_DESCRIPTION: {
    ko: "Target Dataset의 레이블을 수정합니다. (이름은 변경할 수 없습니다.)",
    en: "Edit the label of the Target Dataset. (The name cannot be changed.)",
  },
  TARGET_DATASET_CREATE_SUCCEED: {
    ko: "{name}이(가) 생성되었습니다.",
    en: "{name} has been created.",
  },
  TARGET_DATASET_CREATE_FAIL: {
    ko: "{name} 생성에 실패했습니다.",
    en: "Failed to create {name}.",
  },
  TARGET_DATASET_UPDATE_SUCCEED: {
    ko: "{name}이(가) 수정되었습니다.",
    en: "{name} has been updated.",
  },
  TARGET_DATASET_UPDATE_FAIL: {
    ko: "{name} 수정에 실패했습니다.",
    en: "Failed to update {name}.",
  },
  TARGET_DATASET_DELETE_SUCCEED: {
    ko: "{name}이(가) 삭제되었습니다.",
    en: "{name} has been removed.",
  },
  TARGET_DATASET_DELETE_FAIL: {
    ko: "{name} 삭제에 실패했습니다.",
    en: "Failed to remove {name}.",
  },
  TARGET_VARIABLE_CREATE_SUCCEED: {
    ko: "변수를 추가했습니다.",
    en: "Variable has been added.",
  },
  TARGET_VARIABLE_CREATE_FAIL: {
    ko: "변수 추가에 실패했습니다.",
    en: "Failed to add variable.",
  },
  TARGET_VARIABLE_UPDATE_SUCCEED: {
    ko: "변수를 수정했습니다.",
    en: "Variable has been updated.",
  },
  TARGET_VARIABLE_UPDATE_FAIL: {
    ko: "변수 수정에 실패했습니다.",
    en: "Failed to update variable.",
  },
  TARGET_VARIABLE_DELETE_SUCCEED: {
    ko: "변수를 삭제했습니다.",
    en: "Variable has been removed.",
  },
  TARGET_VARIABLE_DELETE_FAIL: {
    ko: "변수 삭제에 실패했습니다.",
    en: "Failed to remove variable.",
  },

  TARGET_VARIABLE_EDIT_DIALOG_TITLE: {
    ko: "Target Variable 수정",
    en: "Edit Target Variable",
  },
  TARGET_VARIABLE_EDIT_DIALOG_DESCRIPTION: {
    ko: "Target Variable name과 label을 수정합니다.",
    en: "Edit the name and label of the Target Variable.",
  },
  TARGET_VARIABLE_LABEL_EDIT_SUCCEED: {
    ko: "{name}의 라벨이 수정되었습니다.",
    en: "Label for {name} has been updated.",
  },
  TARGET_VARIABLE_LABEL_EDIT_FAIL: {
    ko: "라벨 수정에 실패했습니다. 입력 값을 확인해 주세요.",
    en: "Failed to update label. Please check your input.",
  },
  TARGET_VARIABLE_LABEL_SAME_AS_DEFAULT_VALIDATION: {
    ko: "기존 레이블과 동일합니다. 변경된 내용을 입력해주세요.",
    en: "The label is the same as the default. Please enter a modified value.",
  },
  TARGET_VARIABLE_LABEL_ELLIPSIS_VALIDATION: {
    ko: "Ellipsis(...) 문자를 제거해주세요.",
    en: "Please remove ellipsis (...) characters.",
  },
  TARGET_VARIABLE_LABEL_ELLIPSIS_ICON_TOOLTIP: {
    ko: "라벨을 수정해 주세요.",
    en: "Please update the label.",
  },

  // Convention Setting Dialog
  CONVENTION_SETTING_DIALOG_TITLE: {
    ko: "변수 상세 설정",
    en: "Variable Detail Settings",
  },
  CONVENTION_SETTING_DIALOG_DESCRIPTION: {
    ko: "선택한 변수의 세부 설정을 완료하세요.",
    en: "Complete the detailed settings for the selected variables.",
  },

  // Timing Convention (Row Type 1)
  CONVENTION_TIMING_HELP_TEXT: {
    ko: "Suffix 포함한 사용자 정의 타이밍 변수명, 필수 단어(구문)을 포함한 레이블 지정",
    en: "Specify a user-defined timing variable name with a suffix and a label that includes the required term.",
  },
  CONVENTION_TIMING_NAME_PLACEHOLDER: {
    ko: "Prefix 입력",
    en: "Enter prefix",
  },
  CONVENTION_TIMING_LABEL_PLACEHOLDER: {
    ko: "필수 단어 포함하여 label 작성",
    en: "Write label including mandatory words",
  },
  CONVENTION_TIMING_LABEL_MANDATORY_VALIDATION: {
    ko: "필수 포함되어야 하는 레이블 용어가 누락되었습니다.",
    en: "Mandatory label terms are missing.",
  },

  // Indexed Convention
  CONVENTION_INDEXED_W_HELP_TEXT: {
    ko: "'th' 순차적 의미의 index 지정",
    en: "Specify an index indicating the sequential 'th' position.",
  },
  CONVENTION_INDEXED_XX_HELP_TEXT: {
    ko: "Period Number Index 지정",
    en: "Specify the index for the period number.",
  },
  CONVENTION_INDEXED_Y_HELP_TEXT: {
    ko: "Grouping/categorization scheme, analysis criterion, or analysis range index로 1-2자리 integer [1-99] (zero-padding 하지 않음)",
    en: "Specify the grouping/categorization scheme, analysis criterion, or analysis range index as a 1–2 digit integer [1–99] (no zero padding).",
  },
  CONVENTION_INDEXED_ZZ_HELP_TEXT: {
    ko: "General sequential numbering, period가 아닌 일반 index 로 2자리 zero-padded integer [01-99]",
    en: "Specified as general sequential numbering, a non-period index, using a 2-digit zero-padded integer [01–99].",
  },
  CONVENTION_INDEXED_RANGE_PLACEHOLDER: {
    ko: "Max index 입력 ({min}-{max})",
    en: "Enter max index ({min}-{max})",
  },
  CONVENTION_INDEXED_RANGE_VALIDATION: {
    ko: "정수로 {min}~{max}까지 입력 가능합니다.",
    en: "This variable only accepts integers from {min} to {max}.",
  },
  // SDTM Copy Convention (Row Type 3)
  CONVENTION_SDTM_COPY_HELP_TEXT: {
    ko: "SDTM Dataset을 DDL에서 선택하면, 내부적으로 자동으로 Suffix를 가진 변수 할당",
    en: "When an SDTM dataset is selected in the DDL, the system automatically assigns variables with suffixes.",
  },
  CONVENTION_SDTM_COPY_PLACEHOLDER: {
    ko: "Dataset 선택",
    en: "Select Dataset",
  },
  CONVENTION_SDTM_COPY_NO_VARIABLE_VALIDATION: {
    ko: "해당 변수가 없습니다.",
    en: "The variable does not exist.",
  },

  // Validation
  ALPHA_UPPERCASE_VALIDATION: {
    ko: "영문 대문자만 입력이 가능합니다.",
    en: "Only uppercase English letters are allowed.",
  },
  MIN_LENGTH_VALIDATION: {
    ko: "최소 {length}자 이상 입력해야 합니다.",
    en: "At least {length} characters must be entered.",
  },
  MAX_LENGTH_VALIDATION: {
    ko: "최대 {length}자 까지 입력이 가능합니다.",
    en: "Up to {length} characters can be entered.",
  },
  DUPLICATION_VALIDATION: {
    ko: "중복된 변수가 존재합니다.",
    en: "Duplicate variables found.",
  },

  HEADER_ACTION_VARIABLES_CONFIGURATION: {
    ko: "변수 관리",
    en: "Variables Configuration",
  },

  SELECTION_BAR_SELECTED_COUNT: {
    ko: "{value}개 선택됨",
    en: "{value} selected",
  },
  SELECTION_BAR_SELECT_ALL_BUTTON: {
    ko: "전체 선택",
    en: "Select All",
  },
  SELECTION_BAR_UNCHECK_BUTTON: {
    ko: "선택 항목 해제",
    en: "Uncheck",
  },
  SELECTION_BAR_ADD_TARGET_VARIABLE_BUTTON: {
    ko: "대상 변수 추가",
    en: "Add Target Variable",
  },

  VARIABLE_ENABLE_REORDERING_BUTTON: {
    ko: "순서 변경",
    en: "Reordering",
  },
  VARIABLE_DISABLE_REORDERING_BUTTON: {
    ko: "순서 변경 종료",
    en: "Exit Reordering",
  },
  KEY_REORDERING_TITLE: {
    ko: "키 변수 순서 조정",
    en: "Reordering",
  },
  KEY_RESET_TITLE: {
    ko: "키 초기화",
    en: "Reset",
  },

  VARIABLE_REORDERING_SUCCEED: {
    ko: "{variable} 순서가 저장되었습니다.",
    en: "{variable} order has been saved.",
  },
  VARIABLE_REORDERING_FAIL: {
    ko: "{variable} 순서 저장에 실패했습니다.",
    en: "Failed to save {variable} order.",
  },

  USER_DEFINED_TARGET_VARIABLE_ADD_BUTTON: {
    ko: "사용자 정의 변수 추가",
    en: "Add User-Defined Variable",
  },
  USER_DEFINED_TARGET_VARIABLE_DIALOG_TITLE: {
    ko: "사용자 정의 변수 추가",
    en: "Add User-Defined Variable",
  },
  USER_DEFINED_TARGET_VARIABLE_DIALOG_DESCRIPTION: {
    ko: "데이터셋에 새로운 사용자 정의 변수를 추가합니다. Define-XML 생성을 위해 정확한 속성을 입력해주세요.",
    en: "Define a new variable in accordance with the CDISC ADaM guidelines.",
  },
  USER_DEFINED_TARGET_VARIABLE_DIALOG_NAME_PLACEHOLDER: {
    ko: "변수명 입력 (예: ANLFL)",
    en: "Enter variable name (e.g., ANLFL)",
  },
  USER_DEFINED_TARGET_VARIABLE_DIALOG_LABEL_PLACEHOLDER: {
    ko: "변수에 대한 설명을 입력하세요 (최대 40자)",
    en: "Enter description for the variable (Max 40 chars)",
  },

  // Library Management
  LIBRARY_SAVE_DIALOG_TITLE: {
    ko: "라이브러리에 저장",
    en: "Save to Library",
  },
  LIBRARY_SAVE_DIALOG_DESCRIPTION: {
    ko: "현재 설정을 새로운 라이브러리로 저장합니다.",
    en: "Save the current configuration as a new library.",
  },
  LIBRARY_SAVE_NAME_PLACEHOLDER: {
    ko: "저장할 라이브러리 이름을 입력하세요",
    en: "Enter a name for the library",
  },
  LIBRARY_SAVE_NAME_REQUIRED_VALIDATION: {
    ko: "라이브러리 이름은 필수입니다.",
    en: "Library name is required.",
  },
  LIBRARY_SAVE_NAME_EXISTS_VALIDATION: {
    ko: "중복된 라이브러리 이름이 존재합니다.",
    en: "A library with this name already exists.",
  },

  LIBRARY_LOAD_DIALOG_TITLE: {
    ko: "라이브러리 불러오기",
    en: "Load from Library",
  },
  LIBRARY_LOAD_DIALOG_DESCRIPTION: {
    ko: "저장된 설정을 선택하여 현재 작업에 불러옵니다. 불러오기 시 현재 설정은 모두 초기화됩니다.",
    en: "Select a saved configuration to load. The current settings will be overwritten.",
  },

  LIBRARY_DELETE_DIALOG_TITLE: {
    ko: "라이브러리 삭제 확인",
    en: "Delete Library Confirmation",
  },
  LIBRARY_DELETE_DIALOG_DESCRIPTION: {
    ko: "{name} 라이브러리를 정말 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
    en: "Are you sure you want to delete the {name} library? This action cannot be undone.",
  },

  RESET_CONFIRM_DIALOG_TITLE: {
    ko: "초기화",
    en: "Reset",
  },
  RESET_CONFIRM_DIALOG_DESCRIPTION: {
    ko: "현재 구성된 모든 설정이 삭제되고 초기화 됩니다.\n초기화를 진행하시겠습니까?",
    en: "All current configurations will be deleted and reset.\nAre you sure you want to proceed with the reset?",
  },
  RESET_ALL_SETTINGS_SUCCEED: {
    ko: "모든 설정이 초기화되었습니다.",
    en: "All settings have been reset.",
  },
  RESET_ALL_SETTINGS_FAIL: {
    ko: "전체 설정 초기화에 실패했습니다.",
    en: "Failed to reset all settings.",
  },

  // Library Toast Messages
  LIBRARY_SAVE_SUCCEED: {
    ko: "라이브러리에 저장되었습니다.",
    en: "The library has been saved.",
  },
  LIBRARY_LOAD_SUCCEED: {
    ko: "라이브러리를 불러왔습니다.",
    en: "The library has been loaded.",
  },
  LIBRARY_DELETE_SUCCEED: {
    ko: "라이브러리가 삭제되었습니다.",
    en: "The library has been removed.",
  },
  LIBRARY_RENAME_SUCCEED: {
    ko: "라이브러리 이름이 변경되었습니다.",
    en: "The library has been renamed.",
  },
  LIBRARY_SAVE_FAIL: {
    ko: "라이브러리 저장에 실패했습니다.",
    en: "Failed to save the library.",
  },
  LIBRARY_LOAD_FAIL: {
    ko: "라이브러리 불러오기에 실패했습니다.",
    en: "Failed to load the library.",
  },
  LIBRARY_DELETE_FAIL: {
    ko: "라이브러리 삭제에 실패했습니다.",
    en: "Failed to remove the library.",
  },
  LIBRARY_RENAME_FAIL: {
    ko: "라이브러리 이름 변경에 실패했습니다.",
    en: "Failed to rename the library.",
  },
  LIBRARY_LIMIT_EXCEEDED: {
    ko: "라이브러리 저장 한도({value}개)를 초과했습니다.",
    en: "Library storage limit ({value}) has been exceeded.",
  },

  // Export Toast Messages
  EXPORT_SUCCEED: {
    ko: "내보내기를 완료했습니다.",
    en: "The file has been exported.",
  },
  EXPORT_FAIL: {
    ko: "내보내기에 실패했습니다.",
    en: "Failed to export.",
  },

  // Pair Variable Configuration
  PAIR_VARIABLE_DIALOG_TITLE: {
    ko: "쌍 변수 관계 설정",
    en: "Variable Pairing Configuration",
  },
  PAIR_VARIABLE_DIALOG_DESCRIPTION: {
    ko: "AI를 활용하여 문서에서 쌍 변수 관계를 자동 추출하거나, 수동으로 추가/수정할 수 있습니다. 라이브러리로 저장하여 재사용하세요.",
    en: "You can use AI to automatically extract paired variable relationships from documents, or add and edit them manually. Save them to the library for reuse.",
  },
  PAIR_VARIABLE_DIALOG_TAB_LIST: {
    ko: "쌍 변수 목록",
    en: "Paired Variables List",
  },
  PAIR_VARIABLE_DIALOG_TAB_AI_EXTRACTION: {
    ko: "AI 쌍 변수 추출",
    en: "AI Pair Extraction",
  },
  PAIR_VARIABLE_DIALOG_TAB_LOAD: {
    ko: "불러오기",
    en: "Load from Library",
  },
  PAIR_VARIABLE_DIALOG_TAB_SAVE: {
    ko: "저장",
    en: "Save to Library",
  },
  PAIR_VARIABLE_DIALOG_EMPTY_STATE_MESSAGE: {
    ko: "등록된 데이터가 없습니다.\n수동으로 추가해 주세요.",
    en: "No data registered.\nPlease add manually.",
  },
  PAIR_VARIABLE_DIALOG_ADD_ROW_BUTTON: {
    ko: "행 추가",
    en: "Add",
  },
  PAIR_VARIABLE_DIALOG_IMPORT_BUTTON: {
    ko: "올리기",
    en: "Import",
  },
  PAIR_VARIABLE_DIALOG_LIBRARY_BUTTON: {
    ko: "라이브러리",
    en: "Library",
  },
  PAIR_VARIABLE_DIALOG_COUNT_TOTAL: {
    ko: "총 {total}개 쌍 (AI 생성 {ai}, 수동 생성 {user})",
    en: "Total {total} pairs (AI {ai}, Manual {user})",
  },
  PAIR_VARIABLE_DIALOG_LIBRARY_NAME_LABEL: {
    ko: "라이브러리 이름",
    en: "Library name",
  },
  PAIR_VARIABLE_DIALOG_LIBRARY_NAME_PLACEHOLDER: {
    ko: "라이브러리 이름 (50자 이내)",
    en: "Library name (up to 50 characters)",
  },
  PAIR_VARIABLE_DIALOG_TABLE_HEADER_CHECK: {
    ko: "선택",
    en: "Check",
  },
  PAIR_VARIABLE_DIALOG_TABLE_HEADER_LIBRARY_NAME: {
    ko: "라이브러리 이름",
    en: "Library Name",
  },
  PAIR_VARIABLE_DIALOG_TABLE_HEADER_CREATED_AT: {
    ko: "생성일",
    en: "Created At",
  },
  PAIR_VARIABLE_DIALOG_TABLE_HEADER_PAIR_COUNT: {
    ko: "쌍 변수 수",
    en: "Pair Count",
  },
  PAIR_VARIABLE_DIALOG_TABLE_HEADER_ACTION: {
    ko: "작업",
    en: "Action",
  },
  PAIR_VARIABLE_DIALOG_DUPLICATE_VALIDATION: {
    ko: "중복된 쌍 관계가 존재합니다.",
    en: "A duplicate pair relationship exists.",
  },
  PAIR_VARIABLE_DIALOG_MAX_PAIR_VARIABLES_TOOLTIP: {
    ko: "최대 {value}개까지 생성 가능합니다.",
    en: "You can create up to {value} pair relationships.",
  },
  PAIR_VARIABLE_DIALOG_VARIABLE_CREATE_SUCCEED: {
    ko: "쌍 변수가 추가되었습니다.",
    en: "Pair variable has been added.",
  },
  PAIR_VARIABLE_DIALOG_VARIABLE_CREATE_FAIL: {
    ko: "쌍 변수 추가에 실패했습니다.",
    en: "Failed to add the pair variable.",
  },
  PAIR_VARIABLE_DIALOG_VARIABLE_UPDATE_SUCCEED: {
    ko: "쌍 변수가 수정되었습니다.",
    en: "Pair variable has been updated.",
  },
  PAIR_VARIABLE_DIALOG_VARIABLE_UPDATE_FAIL: {
    ko: "쌍 변수가 수정에 실패했습니다.",
    en: "Failed to update the pair variable.",
  },
  PAIR_VARIABLE_DIALOG_VARIABLE_DELETE_SUCCEED: {
    ko: "쌍 변수가 삭제되었습니다.",
    en: "Pair variable has been deleted.",
  },
  PAIR_VARIABLE_DIALOG_VARIABLE_DELETE_FAIL: {
    ko: "쌍 변수 삭제에 실패했습니다.",
    en: "Failed to delete the pair variable.",
  },
  PAIR_VARIABLE_ADD_CONFIRM_DIALOG_TITLE: {
    ko: "쌍 변수 추가 확인",
    en: "Add Paired Variables Confirmation",
  },
  PAIR_VARIABLE_ADD_CONFIRM_DIALOG_DESCRIPTION: {
    ko: "선택하신 변수와 함께 추가할 쌍 변수를 선택하세요. ",
    en: "Select paired variables to add together with the selected variable.",
  },
  PAIR_VARIABLE_REMOVE_CONFIRM_DIALOG_TITLE: {
    ko: "쌍 변수 삭제 확인",
    en: "Remove Paired Variables Confirmation",
  },
  PAIR_VARIABLE_REMOVE_CONFIRM_DIALOG_DESCRIPTION: {
    ko: "선택하신 변수와 함께 삭제할 쌍 변수를 선택하세요.",
    en: "Select paired variables to remove together with the selected variable. ",
  },
  PAIR_VARIABLE_UNCHECK_CONFIRM_DIALOG_TITLE: {
    ko: "쌍 변수 동시 추가 해제 알림",
    en: "Notification for simultaneous removal of paired variables",
  },
  PAIR_VARIABLE_UNCHECK_CONFIRM_DIALOG_DESCRIPTION: {
    ko: "선택 해제된 항목은 쌍 변수 동시 추가 설정이 적용되어 있습니다.\n해당 설정에 따라 연결된 쌍 변수 항목도 함께 자동 해지되었습니다.",
    en: "The deselected item(s) are configured for paired addition.\nBased on this configuration, the associated paired variable(s) have been automatically removed.",
  },
  PAIR_VARIABLE_UNSAVED_CHANGES_DIALOG_TITLE: {
    ko: "저장되지 않은 변경 사항",
    en: "Unsaved Changes",
  },
  PAIR_VARIABLE_UNSAVED_CHANGES_DIALOG_DESCRIPTION: {
    ko: "입력하신 쌍 변수 정보가 저장되지 않았습니다.\n저장하지 않고 종료하시겠습니까?",
    en: "The paired variable information you entered has not been saved.\nDo you want to close without saving?",
  },
  PAIR_VARIABLE_UNSAVED_CHANGES_DIALOG_CLOSE_WITHOUT_SAVING_BUTTON: {
    ko: "저장하지 않고 닫음",
    en: "Close without saving",
  },

  // 변수 추가 Dialog (Bulk / Predecessor) — CDISC-2549
  ADD_VARIABLES_DIALOG_TITLE: {
    ko: "변수 추가",
    en: "Add Variables",
  },
  ADD_VARIABLES_DIALOG_DESCRIPTION: {
    ko: "데이터셋에 새로운 변수를 추가합니다. 정확한 속성을 입력해주세요.",
    en: "Add new variables to the dataset. Please enter accurate attributes.",
  },
  ADD_VARIABLES_EMPTY_STATE: {
    ko: "등록된 데이터가 없습니다.",
    en: "No data registered.",
  },
  ADD_VARIABLES_ADD_ROW_BUTTON: {
    ko: "행 추가",
    en: "Add",
  },
  ADD_VARIABLES_ROW_LIMIT_GUIDE: {
    ko: "최대 50개의 행까지 추가할 수 있습니다.",
    en: "A maximum of 50 rows can be added.",
  },
  ADD_VARIABLES_HEADER_MODEL: {
    ko: "모델",
    en: "Model",
  },
  ADD_VARIABLES_HEADER_DATASET: {
    ko: "데이터 세트",
    en: "Dataset",
  },
  ADD_VARIABLES_HEADER_VARIABLE: {
    ko: "변수",
    en: "Variable",
  },
  ADD_VARIABLES_HEADER_LABEL: {
    ko: "레이블",
    en: "Label",
  },
  ADD_VARIABLES_HEADER_DATA_TYPE: {
    ko: "데이터 타입",
    en: "Data type",
  },
  ADD_VARIABLES_SELECT_PLACEHOLDER: {
    ko: "선택",
    en: "Select",
  },
  ADD_VARIABLES_TYPE_CUSTOM_LABEL: {
    ko: "사용자 정의",
    en: "User Defined",
  },
  ADD_VARIABLES_CUSTOM_NAME_PLACEHOLDER: {
    ko: "변수명 입력 (예: ANLFL)",
    en: "Enter variable name (e.g., ANLFL)",
  },
  ADD_VARIABLES_CUSTOM_LABEL_PLACEHOLDER: {
    ko: "변수에 대한 설명을 입력하세요 (최대 40자)",
    en: "Enter a description for the variable (max 40 characters)",
  },
  ADD_VARIABLES_DATA_TYPE_CHAR: {
    ko: "문자",
    en: "Char",
  },
  ADD_VARIABLES_DATA_TYPE_NUM: {
    ko: "숫자",
    en: "Num",
  },
  ADD_VARIABLES_SUCCEED: {
    ko: "변수가 추가되었습니다.",
    en: "The variables have been added.",
  },
  ADD_VARIABLES_FAIL: {
    ko: "변수 추가에 실패했습니다.",
    en: "Failed to add the variables.",
  },
  ADD_VARIABLES_NAME_IN_USE: {
    ko: "이미 사용 중인 변수명입니다.",
    en: "This variable name is already in use.",
  },
  ADD_VARIABLES_NAME_DUPLICATE_IN_MODAL: {
    ko: "입력 모달 내 다른 행과 변수명이 중복됩니다.",
    en: "This variable name conflicts with another row in the modal.",
  },
  ADD_VARIABLES_CANDIDATE_DUPLICATE_TOOLTIP: {
    ko: "현재 데이터셋 Candidate에 동일한 변수가 이미 있습니다.",
    en: "A matching variable already exists in this dataset's candidate variables.",
  },
  ADD_VARIABLES_CUSTOM_NAME_RULE_VIOLATION: {
    ko: "변수명은 영문 대문자, 숫자, 언더스코어(_)만 사용할 수 있으며, 최대 32자이고 첫 글자는 영문 대문자여야 합니다.",
    en: "Variable names may contain only uppercase letters, digits, and underscore (_), max 32 characters, and must start with an uppercase letter.",
  },
  ADD_VARIABLES_NO_SDTM_DATASET: {
    ko: "참조할 Dataset이 Define-XML에 존재하지 않습니다.",
    en: "The referenced dataset does not exist in the Define-XML.",
  },
  PREDECESSOR_BADGE_LABEL: {
    ko: "Predecessor",
    en: "Predecessor",
  },
  PREDECESSOR_BADGE_DANGLING: {
    ko: "참조 소스 삭제됨",
    en: "Reference source deleted",
  },
};

MvnCodeInitiate(CONVERTER_STUDY_ADAM_DATASET_LANG);
